import React from 'react'
import logo from '../../assets/images/logo-ALS.svg'
import logoCenter from '../../assets/images/logo-ALS-center.svg'

import './style.scss'

class Copyright extends React.Component {
  render() {
    return (
      <div className="copyright">
        Задизайнено
        {
          this.props.windowWidth > 768 ? ' ' : <br/>
        }
        в <a rel="noopener noreferrer" href="https://www.artlebedev.ru/" target="_blank">
        {
          this.props.windowWidth > 768 ?
            <img alt="Студия Артемия Лебедева" src={logo} width="100" height="46"/>
            :
            <img alt="Студия Артемия Лебедева" src={logoCenter} width="100" height="46"/>
        }
        Студии Артемия Лебедева</a>
        <br/>
        <a rel="noopener noreferrer" href="https://www.artlebedev.ru/cbr/160/" target="_blank">Информация о&nbsp;сайте</a>
      </div>
    )
  }
}

export default Copyright
